import React, {forwardRef, useEffect, useLayoutEffect, useState, useRef} from 'react';
import ReactDOM from 'react-dom';
import gsap from 'gsap';
import useIsTablet from '../hooks/useIsTablet';
import useIsDesktop from '../hooks/useIsDesktop';
import CloseButton from './CloseButton';
import '../css/definition.css';

const Definition = forwardRef(({tooltipContent, position, closeDefinition}, ref) => {

  const portalRootRef = useRef();
  const definitionRef = useRef();
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();
  const [mounted, setMounted] = useState(false);
  const width = 400;
  const [arrowPositionClass, setarrowPositionClass] = useState("top-arrow");
  const [arrowMargin, setarrowMargin] = useState(-35);
  const [arrowLeft, setarrowLeft] = useState(50);

  const closeHandler = (e) => {
    try {
      gsap.to(definitionRef.current, {
        opacity: 0, duration: .5, ease: "power4.out",
        onComplete: () => {
          closeDefinition();
          if (portalRootRef.current) {
            portalRootRef.current.style.opacity = 0;
       }
          // portalRootRef.current.style.opacity = 0;
        }
      })
    } catch (e) { 
      console.log(`Error closing definition: ${e}`);
    }
    
    e.preventDefault();
    e.stopPropagation();
  };

  // ensure the component is mounted before trying to create the portal and render the component
  //    if mounted, animate the opening of the definition
  useLayoutEffect(() => {
    setMounted(true);

    try {
      if (!definitionRef.current) {
        definitionRef.current = document.createElement("div");
        definitionRef.current.id = "DefinitionPortal";
      }
      gsap.from(definitionRef.current, {
        opacity: 0, duration: .5, delay: .1, ease: "power4.out",
        onStart: () => {
          if (!portalRootRef.current) {
            portalRootRef.current = document.createElement("div");
            portalRootRef.current.id = "DefinitionPortal";
          }
          portalRootRef.current.style.opacity = 1;
        }
      });
    } catch (e) {
      console.log(`Error opening definition: ${e}`);
    }

    return () => {
      // unmount the component when the user closes the definition
      setMounted(false);
    };
  }, [definitionRef.current, tooltipContent.id, portalRootRef.current]);

  const clickCatcher = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // recalculate the position of the definition tooltip if it's off the screen in desktop mode
  useLayoutEffect( () => {

    if (isDesktop) {
      const rect = definitionRef.current.getBoundingClientRect();
      const body = portalRootRef.current;
  
      const offBottom = rect.top + rect.height > body.clientHeight;
      const offRight = rect.left + rect.width > body.clientWidth;
      const offLeft = rect.left < 0;
      
      setarrowLeft(50)
      if (offLeft) {
        definitionRef.current.style.marginLeft = `${-rect.left + 60}px`;
        setarrowMargin(-((rect.left * -1) + 60 + 35));
      }
      
      if (offBottom) {
        definitionRef.current.style.marginTop = `${-rect.height - 50}px`;
        setarrowPositionClass("bottom-arrow");
      }
      if (offRight) {
        definitionRef.current.style.marginLeft = `${-((rect.left + rect.width) - body.clientWidth + 60 )}px`;
        setarrowMargin( ((rect.left + rect.width) - body.clientWidth + 60 ) - 35)
      }
    }
    
    if (isTablet) {
      const rect = definitionRef.current.getBoundingClientRect();
      const body = portalRootRef.current;
      const offTop = rect.top < 274

      if(offTop){
        // definitionRef.current.style.marginTop = `${(-rect.top + 60) + 120}px`;
        definitionRef.current.style.top = `${position.y + 90}px`;
        setarrowPositionClass("top-arrow");
        setarrowLeft(0);
        setarrowMargin(position.x - 35);
      }

      else{
        const definitionHeight = definitionRef.current.clientHeight;
        definitionRef.current.style.transform = `translateY(-${definitionHeight}px)`;

        // definitionRef.current.style.top = `${position.centerY - 140}px`;
        setarrowPositionClass("bottom-arrow")
        setarrowLeft(0)
        setarrowMargin(position.x - 35)
      }

    };
    
    
  }, [definitionRef, portalRootRef, mounted, isTablet, isDesktop]);

  // if the user scrolls and the definition is open, close it
  useEffect(() => {
    const handleScroll = () => {
      closeDefinition();
      window.removeEventListener('scroll', handleScroll);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, [closeDefinition]);

  return mounted ? ReactDOM.createPortal(
    <div ref={portalRootRef} id={`Definition-${tooltipContent.id}`} onClick={closeHandler} className="definitionTooltipContaner opacity-0 fixed top-0 left-0 w-screen h-screen z-[99999999999999]">
      <div 
        ref={definitionRef} 
        onClick={clickCatcher}
        className={`def-box ${arrowPositionClass} absolute pointer-events-auto 
          text-left leading-tight text-[18px]
          bg-black bg-opacity-100 shadow-definition 
          border-2 border-white rounded-2xl p-4
          w-[calc(100%-3rem)] translate-y-[-0%]  mt-[-50px] ml-4b
          lg:w-[400px] lg:translate-y-0 lg:mt-0 lg:ml-0 
        `}
        style={{
          top: position.y + position.height + 10,
          left: !isTablet && (position.x + (position.width / 2) - width / 2)
        }}
      >
        <div className="arrowBox" style={{ marginLeft: `${arrowMargin}px`, left: `${arrowLeft}%`}}></div>
        <strong className="block text-white pb-[4px]">{tooltipContent.title}</strong>

        <p className="block font-normal italic pb-[5px] text-watermelon text-[17px]">{tooltipContent.pronunciation}</p>
        
        <p className="text-[18px] leading-[21px] text-white">{tooltipContent.content}</p>
        
        <button onClick={closeHandler} className="absolute z-10 right-[-22px] top-[-22px] cursor-pointer">
          <CloseButton />
        </button>
      </div>
    </div>,
    document.getElementById("VideoContainer")
  ) : null;
});

export default Definition;
